import React from 'react'
import * as yup from "yup";
import Input from './Input';
import Button from './Button';
import { Link } from 'react-router-dom';

const validate_data = async (data = {}) => await yup.object().shape({

  city: yup.string().required('Enter Valid City'),

  last_name: yup.string().required('Enter Last Name'),

  first_name: yup.string().required('Enter First Name'),

  location: yup.string().required('Enter Valid Address'),

  address_2: yup.string().required('Enter Apartment, Suite, House or Floor No.'),

  phone_no: yup.string().min(9).max(10).required('Enter Valid Postal Code'),

  email_address: yup.string()
    .email("Invalid Email Address")
    .required("Email Address is required!"),

}).validate(data, { abortEarly: true }).catch(({ path, message }) => ({
  error_messages: { [path] : message }
}));

export default ({ values, onChangeEvent, onError, onSubmit }) => {

  const {
    city,
    step,
    errors,
    location,
    address_2,
    last_name,
    first_name,
    phone_no,
    authenticated,
    email_address
  } = values;

  const validate_form = async () => {

    const { error_messages } = await validate_data(values);

    return (!!error_messages) ? onError(error_messages) : onSubmit();

  }

  return (step===1) && (
    <div className='Contact-Information'>

      <div className="Title">
        { (!authenticated) &&
          <div className="Caption">
            <span>Already have an Account? </span>
            <Link to='/login' className='bold'>Login</Link>
          </div>
        }
      </div>

      <Input
        type='email'
        name='email_address'
        value={email_address}
        onChange={onChangeEvent}
        placeholder={'Email Address'}
        error={errors['email_address']}
      />

      <Input
        name='first_name'
        value={first_name}
        pattern={'no-space'}
        onChange={onChangeEvent}
        placeholder={'First Name'}
        error={errors['first_name']}
      />

      <Input
        name='last_name'
        value={last_name}
        pattern={'no-space'}
        onChange={onChangeEvent}
        placeholder={'Last Name'}
        error={errors['last_name']}
      />

      <Input
        name='location'
        value={location}
        onChange={onChangeEvent}
        error={errors['location']}
        placeholder={'Delivery Address'}
      />

      <Input
        name='address_2'
        value={address_2}
        onChange={onChangeEvent}
        error={errors['address_2']}
        placeholder={'Building, House No, Directions'}
      />

      <Input
        name='city'
        value={city}
        error={errors['city']}
        onChange={onChangeEvent}
        placeholder={'City/Region'}
      />

      <Input
        name='phone_no'
        value={phone_no}
        onChange={onChangeEvent}
        error={errors['phone_no']}
        placeholder={'Mobile Phone No.'}
      />

      <Button
        label='Continue to Shipping'
        onClickEvent={() => validate_form()}
      />

    </div>
  )
}
